<template>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.4/tiny-slider.css"
  />
  <div class="third-step">
    <div class="third-step__container">
      <div class="steps__title"><span>3.1</span> Selecciona el Día y Hora:</div>
      <div class="third-step__date">
        <div class="third-step__date-slider">
          <div
            class="date__container"
            v-for="(date, index) in dates"
            :key="date.month + date.day"
            :class="{ disable: !date.status }"
          >
            <input
              type="radio"
              name="date"
              :id="'date' + index"
              v-model="order.schedule_date"
              :value="date.full"
            />
            <label :for="'date' + index" class="date__element">
              <div class="date__month">{{ date.month }}</div>
              <div class="date__day">{{ date.day }}</div>
            </label>
          </div>
        </div>
      </div>
      <div class="third-step__hour">
        <div class="third-step__hour-slider">
          <div
            class="hour__container"
            v-for="(hour, index) in hours"
            :key="hour"
          >
            <input
              type="radio"
              name="hour"
              :id="'hour' + index"
              v-model="order.schedule_time"
              :value="hour"
            />
            <label :for="'hour' + index" class="hour__element">
              {{ hour }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="next-step">
      <a
        href="#"
        class="btn btn--outline"
        @click.prevent="prevStep()"
        v-if="order.id == ''"
        >Regresar</a
      >
      <button type="submit" class="btn btn--green">
        {{ !order.hasOwnProperty('id') ? 'Finalizar' : 'Reprogramar' }}
      </button>
    </div>
  </div>
</template>

<script>
import { tns } from 'tiny-slider'
import { inject } from 'vue'

export default {
  mounted() {
    let dateSlider = tns({
      container: '.third-step__date-slider',
      slideBy: 'page',
      mouseDrag: true,
      loop: false,
      nav: false,
      gutter: 0,
      responsive: {
        0: {
          items: 4,
        },
        667: {
          items: 6,
        },
        992: {
          items: 8,
        },
      },
    })

    let hourSlider = tns({
      container: '.third-step__hour-slider',
      slideBy: 'page',
      mouseDrag: true,
      loop: false,
      nav: false,
      gutter: 0,
      autoWidth: true,
    })
  },
  setup() {
    const order = inject('order')
    const dates = inject('dates')
    const hours = inject('hours')
    const flag = inject('flag')

    const prevStep = () => {
      flag.value = 2
    }

    return {
      order,
      dates,
      hours,
      prevStep,
    }
  },
}
</script>
<style></style>
